// src/components/Sidebar/components/TreeEventCard.jsx
import React from "react";
import { Box, Card, CardActionArea, Chip, Typography } from "@mui/material";

export default function TreeEventCard({ onClick }) {
    return (
        <Box sx={{ px: 2, pb: 1.5 }}>
            <Card
                elevation={0}
                sx={{
                    borderRadius: 3,
                    overflow: "hidden",
                    border: "1px solid rgba(0,0,0,0.10)",
                    boxShadow: "0 8px 18px rgba(0,0,0,0.10)",
                }}
            >
                <CardActionArea
                    onClick={onClick}
                    sx={{
                        position: "relative",
                        p: 2,
                        background:
                            "linear-gradient(135deg, rgba(220,20,60,0.14), rgba(255,255,255,0.92) 45%, rgba(0,160,80,0.14))",
                    }}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            inset: 0,
                            pointerEvents: "none",
                            opacity: 0.9,
                            background: `
                radial-gradient(circle at 18% 25%, rgba(255,255,255,0.55), transparent 40%),
                radial-gradient(circle at 80% 30%, rgba(255,255,255,0.45), transparent 42%),
                radial-gradient(circle at 55% 85%, rgba(255,255,255,0.35), transparent 45%)
              `,
                        }}
                    />

                    <Box sx={{ position: "relative", display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography sx={{ fontWeight: 900, letterSpacing: "-0.02em", lineHeight: 1.1 }}>
                            🎄 트꾸
                        </Typography>
                        <Chip size="small" label="진행중" color="success" sx={{ height: 20, fontWeight: 900 }} />
                    </Box>

                    <Typography
                        sx={{
                            position: "relative",
                            mt: 0.75,
                            fontSize: 12.5,
                            color: "text.secondary",
                            lineHeight: 1.3,
                        }}
                    >
                        지금 참여해서 산들 트리를 함께 꾸며봐요 ✨
                    </Typography>

                    <Box
                        sx={{
                            position: "relative",
                            mt: 1.2,
                            height: 2,
                            width: 52,
                            borderRadius: 999,
                            backgroundColor: "rgba(0,0,0,0.14)",
                        }}
                    />
                </CardActionArea>
            </Card>
        </Box>
    );
}
